<template>
  <div class="">
    <h1>ساعات ورود و خروج</h1>

    <div class="my-3" v-for="(items,index) in checkInOut">
      <p>{{ weekNames[index] }}</p>

      <div class="row">
        <div class="col">
          <label>حداقل ساعت ورود</label>
          <input type="time" required v-model="items['check_in']['min']" class="form-control text-center px-5 "
                 dir="ltr">
        </div>

        <div class="col">
          <label>حداکثر ساعت ورود</label>
          <input type="time" required v-model="items['check_in']['max']" class="form-control text-center px-5 "
                 dir="ltr">
        </div>

        <div class="col">
          <label>حداکثر ساعت خروج</label>
          <input type="time" required v-model="items['check_out']['max']" class="form-control text-center px-5 "
                 dir="ltr">
        </div>
      </div>


    </div>


  </div>
</template>

<script>

export default {
  name: "CheckInOutManager",
  props: {
    checkInOut: {}
  },
  data() {
    return {
      weekNames: [
        'دوشنبه',
        'سه شنبه',
        'چهارشنبه',
        'پنجشنبه',
        'جمعه',
        'شنبه',
        'یکشنبه',
      ]
    }
  }
}
</script>


<style scoped>

</style>